import { createContext } from "react";
import { GroupRosterIdentity } from "@jd/jdee.im.sdk/lib/es/model/Roster";
import { GroupRoster, Session, Employee, AIMergeOptions } from "@/types/chat";
import { UserModel } from "@/models/user";
import { DrawTypeEnum } from "@/components/chat/enum";
import { QuickReplyConfig } from "@jd/jdee.im.sdk/lib/es/utils/types";

export default createContext<{
  currentEmployee: Employee;
  groupRosters: Partial<GroupRoster>[];
  groupRosterIdentity: GroupRosterIdentity | "";
  userData: UserModel;
  onToggleSetup?: (type: DrawTypeEnum) => void;
  closeSetting?: () => void;
  isSmall?: boolean;
  isLLMAI?: boolean;
  assistantAI?: any;
  lastMessage?: any;
  lastAIMessage?: any;
  httpMatchUrls?: string[];
  blackUrls?: string[];
  isMeetingChat?: boolean;
  isLiveMeetingChat?: boolean;
  imService?: any;
  isAIChatSelectedSession?: boolean;
  quickReplyConfig?: QuickReplyConfig;
  userQuickReply?: number;
  aggregateDuration?: number;
  fileTagList?: any[]; // 文件标签列表
  currentFileControl?: any[]; // 当前文件操作权限
  currentFileSendControl?: any[]; // 当前文件发送权限
  defaultFileTag?: number; // 默认文件类型
  aiMergeOptions?: AIMergeOptions;
}>({} as any);
